import { Injectable } from '@angular/core'
import { BehaviorSubject, Observable} from 'rxjs'


@Injectable({
  providedIn: 'root'
})
export class LoanOptionsService {

  latestType: 'user' | 'coapp'
  loanResponse: any
  loanAcctId: string
  coappLoanResponse: any
  coappLoanAcctId: string
  coappMobileNumber: string


  constructor() {}

}
